// extracted by mini-css-extract-plugin
export var avatarWrapper = "post-metadata-module--avatarWrapper--s+GDz";
export var dot = "post-metadata-module--dot--dZU1Y";
export var metadata = "post-metadata-module--metadata---W+G7";